export default "__VITE_PUBLIC_ASSET__af1b9825__"